<div class="fluxo-realizado-container">
  <div class="topo-relatorio">
    <div class="titulo-relatorio">Fluxo de Caixa Diario Realizado</div>
  </div>

  <div class="filtros-relatorio">
    <div class="d-flex align-items-center flex-wrap gap-2">
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="alterarAno(-1)">
        <i class="fa fa-chevron-left"></i>
      </button>
      <span class="ano-pill">{{ ano }}</span>
      <button type="button" class="btn btn-outline-primary btn-sm" (click)="alterarAno(1)">
        <i class="fa fa-chevron-right"></i>
      </button>
    </div>

    <div class="saldo-inicial-group">
      <label>Saldo inicial</label>
      <input type="number" class="form-control form-control-sm" [(ngModel)]="saldoInicialPeriodo" />
    </div>

    <button type="button" class="btn btn-primary btn-sm" (click)="carregarRelatorio()">
      <i class="fa fa-refresh"></i> Atualizar
    </button>
  </div>

  <div class="resumo-relatorio">
    <div class="resumo-box">
      <div class="resumo-label">Saldo do dia:</div>
      <div class="resumo-data">{{ saldoDiaData || '-' }}</div>
      <div class="resumo-valor">R$ {{ formatMoney(saldoDiaValor) }}</div>
    </div>
    <div class="resumo-box">
      <div class="resumo-label">Saldo final do periodo:</div>
      <div class="resumo-data">{{ saldoFinalData || '-' }}</div>
      <div class="resumo-valor">R$ {{ formatMoney(saldoFinalValor) }}</div>
    </div>
  </div>

  <div
    #tabelaScroll
    class="card-box table-responsive"
    [class.dragging-table]="arrastandoTabela"
    (mousedown)="iniciarArrasteTabela($event, tabelaScroll)"
    (mousemove)="moverArrasteTabela($event, tabelaScroll)"
    (mouseup)="encerrarArrasteTabela()"
    (mouseleave)="encerrarArrasteTabela()">
    <table class="table table-bordered table-sm table-striped table-hover fluxo-realizado-table">
      <thead>
        <tr>
          <th>
            <span class="th-inner">Data</span>
            <i class="fa fa-filter th-filtro" aria-hidden="true"></i>
          </th>
          <th>
            <span class="th-inner">Dia da semana</span>
            <i class="fa fa-filter th-filtro" aria-hidden="true"></i>
          </th>
          <th>
            <span class="th-inner">Saldo inicial</span>
            <i class="fa fa-filter th-filtro" aria-hidden="true"></i>
          </th>
          <th>
            <span class="th-inner">Entradas</span>
            <i class="fa fa-filter th-filtro" aria-hidden="true"></i>
          </th>
          <th>
            <span class="th-inner">Saídas</span>
            <i class="fa fa-filter th-filtro" aria-hidden="true"></i>
          </th>
          <th>
            <span class="th-inner">Saldo final</span>
            <i class="fa fa-filter th-filtro" aria-hidden="true"></i>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="6" class="text-center text-muted py-3">Carregando...</td>
        </tr>
        <tr *ngIf="!loading && !linhas.length">
          <td colspan="6" class="text-center text-muted py-3">Nenhum dado encontrado para o periodo.</td>
        </tr>
        <tr *ngFor="let linha of linhas">
          <td>{{ linha.dataExibicao }}</td>
          <td class="text-capitalize">{{ linha.diaSemana }}</td>
          <td class="text-end">R$ {{ formatMoney(linha.saldoInicial) }}</td>
          <td class="text-end">{{ formatEntradaSaida(linha.entradas) }}</td>
          <td class="text-end">{{ formatEntradaSaida(linha.saidas) }}</td>
          <td class="text-end col-saldo-final">R$ {{ formatMoney(linha.saldoFinal) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
